import * as React from 'react';

import Icon from 'components/Icon';
import Text from 'components/Text';
import TooltipTrigger from 'components/TooltipTrigger';
import RosterConstants from 'constants/RosterConstants';
import GroupAvatarWithText from 'groups/components/GroupAvatarWithText';
import { PartialUnclaimedGroupProfileType } from 'groups/components/UnclaimedGroupProfile';

type Props = {
  group: PartialUnclaimedGroupProfileType;
};

export default function UnclaimedGroupProfileHeader({ group, ...others }: Props) {
  return (
    <div className="UnclaimedGroupProfileHeader">
      <GroupAvatarWithText
        {...others}
        avatarSize="large"
        icon={
          <TooltipTrigger placement="top" tooltip={RosterConstants.rosteredLabel}>
            <span>
              <Icon
                color={RosterConstants.rosteredColor}
                name={RosterConstants.rosteredIcon}
                size="xlarge"
              />
            </span>
          </TooltipTrigger>
        }
        group={group}
        subtext={
          <React.Fragment>
            <Text>Unclaimed </Text>
            {
              <TooltipTrigger
                tooltip="This class was created by your SIS and hasn’t been claimed by its class owner. Participants can’t see unclaimed classes."
                placement="top">
                <span>
                  <Icon name="question-circle" size="inherit" />
                </span>
              </TooltipTrigger>
            }
          </React.Fragment>
        }
        level="primary"
      />
    </div>
  );
}
